import {
  addToApiErrors,
  addToLoadingQueve,
  removeFromLoadingQueve,
} from "@/state/appState";
import { ApiCallOptions, Dict, SfApiError } from "@/types/generalTypes";
import buildApiUrl from "./buildApiUrl";
import getCsrfToken from "./getCsrfToken";

const defaultReqOptions = {
  cache: "no-cache",
  mode: "cors",
  headers: { "Content-Type": "application/json" },
} as RequestInit;

const defaultApiOptions = {
  withLoading: true,
  customErrorsCB: null,
};

export default async function (
  path: string,
  params: Dict<any> | null = null,
  reqOptions?: RequestInit | null,
  body?: Dict<any> | FormData | null,
  apiOptions?: ApiCallOptions | null,
  silentError?: boolean,
) {
  const url = buildApiUrl(path, params);
  const res = {
    data: {} as Dict<any>,
    httpStatus: 0,
    success: false,
    statusText: null as any,
    errorDetails: null as any,
  };
  const options = { ...defaultApiOptions, ...apiOptions };
  const lid = options.withLoading ? addToLoadingQueve() : 0;
  try {
    let sendOptions = { ...defaultReqOptions, ...reqOptions };
    if (body) {
      if (body instanceof FormData) {
        sendOptions = { method: reqOptions?.method, body };
      } else {
        body._csrf = getCsrfToken();
        sendOptions.body = JSON.stringify(body);
      }
    }
    const response = await fetch(url, sendOptions);
    res.httpStatus = response.status;
    res.statusText = response.statusText;
    const resBody = await getJsonBody(response);
    if (response.status >= 200 && response.status < 300) {
      res.success = true;
      res.data = resBody;
    } else {
      if (resBody) {
        const error = resBody;
        res.errorDetails = error;
        if (
          !options.customErrorsCB ||
          options.customErrorsCB(res.httpStatus, resBody)
        ) {
          if (!silentError) {
            addToApiErrors({ ...error, status: response.status } as SfApiError);
          }
        }
      } else {
        if (!silentError) {
          addToApiErrors({
            status: response.status,
            code: -1,
            message: "",
            name: "unknown",
            type: "unknown",
          });
        }
      }
    }
  } catch (e) {
    res.errorDetails = e;
    if (!silentError) {
      addToApiErrors({
        status: 0,
        code: -2,
        message: e as string,
        name: "failed",
        type: "failed",
      });
    }
  }
  if (lid > 0) {
    removeFromLoadingQueve(lid);
  }
  return res;
}

async function getJsonBody(response: Response) {
  const contentType = response.headers.get("Content-Type")?.split("; ");
  if (
    response.body &&
    contentType &&
    contentType?.indexOf("application/json") >= 0
  ) {
    return await response.json();
  }
  return null;
}
